import React from 'react'
import AlsoKnownAs from './AlsoKnownAs'
import GptComponentPerson from './GptComponentPerson'
import NameField from './Namefield'
// import PopularPerson from './PopularPerson'
import ShortBioField from './ShortBioField'
// import GoatAndPopular from '../Movie/GoatAndPopular'
import InternalComments from '../Movie/InternalComments'

function PopularPersonNameFieldBioPopularlyKnownas(props) {
  const {
    PersoninputData,
    sendInputdata,
    sendValuechangedBoolean,
    disableInput,
    personName,
    personNamete,
    error,
    handleNameChange,
    handleNameteChange,
    shortBio,
    shortBiote,
    setShortbio,
    setShortbiote,
    // handleShortbioChange,
    // handleShortbioteChange,
  } = props

  // function for handling change of shotbio english
  const handleShortbioChange = e => {
    sendValuechangedBoolean('bio', true)
    setShortbio(e.target.value)
  }

  const handleShortbioteChange = e => {
    sendValuechangedBoolean('biote', true)
    setShortbiote(e.target.value)
  }

  return (
    <>
      {/* component for selecting person is popular or not */}
      {/* <PopularPerson
        inputData={PersoninputData}
        sendinputdata={sendInputdata}
        sendValuechangedBoolean={sendValuechangedBoolean}
        disableInput={disableInput}
      /> */}
      {/* <GoatAndPopular
        inputData={PersoninputData}
        Popular={PersoninputData.popularPerson}
        sendInputData={sendInputdata}
        sendBooleanValueChangeDone={sendValuechangedBoolean}
        GOAT={PersoninputData.GOAT}
        type={'person'}
      /> */}
      {/* component for entering or editing person Name */}
      <NameField
        disableInput={disableInput}
        personName={personName}
        personNamete={personNamete}
        error={error}
        handleNameChange={handleNameChange}
        handleNameteChange={handleNameteChange}
      />
      {/* component for entering or editing popularly known by Name */}
      <AlsoKnownAs
        inputData={PersoninputData}
        sendinputdata={sendInputdata}
        sendBooleanValueChangeDone={sendValuechangedBoolean}
        disableInput={disableInput}
      />
      {/* component for entering or editing bio of person */}
      <ShortBioField
        disableInput={disableInput}
        shortbio={shortBio}
        shortbiote={shortBiote}
        error={error}
        handleShortbioChange={handleShortbioChange}
        handleShortbioteChange={handleShortbioteChange}
        setShortbio={setShortbio}
        setShortbiote={setShortbiote}
        sendValuechangedBoolean={sendValuechangedBoolean}
      />
      <GptComponentPerson
        personName={personName}
        Dob={PersoninputData && PersoninputData.dateOfBirth ? PersoninputData.dateOfBirth : ''}
      />
      <InternalComments
        inputData={PersoninputData}
        sendinputdata={sendInputdata}
        sendBooleanValueChangeDone={sendValuechangedBoolean}
      />
    </>
  )
}

export default PopularPersonNameFieldBioPopularlyKnownas
